<template>
<div>
<div class="content_card" >
<div class="grid">

<div class="col-12">
<div class="content_card_content">
	<div class="grid">

		<div class="col-12">
			<AutoComplete 
			v-model="selectedsupplier" 
			class="w-full p-inputtext-sm" 
			field="name" 
			:loading="loading"
			:suggestions="filteredsuppliers" 
			@complete="search"
			@input="textstart"
			placeholder="Firma ismi ya da kodu"
			@item-select="itemSelected">

			<template #option="slotProps">                                  
          	{{ slotProps.option.name }} - {{ slotProps.option.suppliercode}}          
      		</template>
				
			</AutoComplete>
		</div>


		<div class="col-12" v-if="itemselected">

			<template v-if="shownoflowsupplier">
			<h4 class="text-red-500 font-bold">Bu firma için 2023 yılına atanan bir aşama kaydı yok</h4>
			</template>

			<template v-else>
				<h4 class="text-primary">{{selectedsupplier.name}}</h4>
				<FileUpload   accept=".xlsx, .xls, .csv" @select="onFilesAdded"  @remove="onFilesRemove"   v-model="files" :multiple="false" :showUploadButton="false" :showCancelButton="false" :chooseLabel="$store.state.languages.lang_phrases.dosya_secin" :fileLimit="1"   :maxFileSize="10000000" class="">
				  <template #empty>
				      <p>{{$store.state.languages.lang_phrases.dosyayi_surukleyip_birakin}}</p>
				  </template>
				</FileUpload>

				<div class="flex align-items-center justify-content-center mb-8 mt-8 flex-column" v-if="reading_document">
				<h3 class="text-primary font-medium">Döküman Taranıyor</h3>
				</div>

				<div class="flex align-items-center justify-content-center mb-2 mt-2 flex-column" v-if="ready_to_upload">
					<h3 class="text-primary font-medium">Kaydetmeye Hazır</h3>
						<Button :label="$store.state.languages.lang_phrases.tamamla" class="p-button-outlined p-button-primary p-button-sm ml-2"  icon="pi pi-check" @click="submitResults" :loading="$store.state.ui.submitting"/>
						<template v-if="unregistered_smelters.length">
							<h4 class="text-red-500">Aşağıdaki Smelterlar Sisteme Kayıtlı Değiller</h4>
							<ul>
								<li v-for="item in unregistered_smelters">{{item}}</li>
							</ul>
							
						</template>
				</div>

				

				<BeyzayaOzelSection v-for="section in $store.state.evaluation.parentsections" :section="section"  />
				
			</template>

			
			

		</div>







	</div>
</div>
</div>

</div>
</div>
</div>
</template>

<script>
import * as XLSX from 'xlsx/xlsx.mjs';
import moment from "moment"
import BeyzayaOzelSection from "./BeyzayaOzelSection"
const columns_arr = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","AA","AB","AC","AD","AE","AF","AG","AH","AI"];
export default {

  name: 'BeyzayaOzel',

  data () {
    return {
    	loading:true,
    	files:[],
    	questionlist:null,
    	selectedsupplier:null,
    	itemselected:false,
    	filteredsuppliers:null,
    	worksheet:null,
    	workbook:null,
    	current_row:0,
    	current_column:0,
    	flowsupplierdata:null,
    	shownoflowsupplier:false,
    	reading_document:false,
    	ready_to_upload:false,
    	unregistered_smelters:[],
    }
  },
  components:{BeyzayaOzelSection},
  mounted()
  {
  	this.getData()
  },
  methods:{
  	submitResults()
  	{
  		console.log(this.$store.state.evaluation.evaluation)
  		let formdata = new FormData()
  		formdata.append("flowsupplier_id",this.$store.state.evaluation.evaluation.id)
  		let submissions = []
  		for(let item of this.$store.state.evaluation.inputfields)
  		{
  			let sub_obj = {
  				inputfield_id:item.id,
  				submission_text:null,
  				type:item.type,
  				submission_numerical:null,
  				submission_option:null,
  				submission_note:null,
  			}
  			if(item.submissions.length)
  			{
  				if(item.type=="number")
  				{
  					sub_obj.submission_numerical = item.submissions[0].submission_numerical
  				}
  				else if(item.type=="select")
  				{
  					sub_obj.submission_option = item.submissions[0].submission_option
  				}
  				else if(item.type=="text" || item.type=="longtext")
  				{
  					sub_obj.submission_text = item.submissions[0].submission_text
  				}
  				else
  				{
  					sub_obj.submission_text = item.submissions[0].submission_text
  				}
  				if(item.submissions[0].submission_note)
  				{
  					sub_obj.submission_note = item.submissions[0].submission_note
  				}
  				submissions.push(sub_obj)
  			}
  		}
  		//loop inputfields
  		console.log(submissions)
  		formdata.append("subs",JSON.stringify(submissions))

  		this.generalSubmission(formdata,"audit/submit_flowsupplier_for_beyza",this.aftersubmitResults)
  		
  	},
  	aftersubmitResults(response)
  	{
  		console.log(response.data)
  	},	
  	onFilesRemove()
  	{
  		this.textstart()
  	},
  	async getData()
  	{
  		//this.questionlist = await this.silentApiGet("suppliers_full?searchterm="+data.query)
  	},
  	fieldChanged()
  	{

  	},
  	async search(data)
  	{
  		console.log("search")
  		this.itemselected = false
  		this.loading = true
  		let filteredsuppliers = await this.silentApiGet("suppliers_full?searchterm="+data.query)
  		for(let filteredsupplier of filteredsuppliers)
  		{
  			filteredsupplier.name = filteredsupplier.name + " - "+filteredsupplier.suppliercode
  		}
  		this.filteredsuppliers = filteredsuppliers
  		console.log(this.filteredsuppliers)
  		this.loading = false
  	},
  	async getFlowsupplierData(data)
  	{
  		let flowsupplierdata = await this.silentApiGet("audit/get_flowsupplier_for_beyza/"+data.value.id)
  		console.log(flowsupplierdata)
  		if(flowsupplierdata=="no_flowsupplier")
  		{
  			this.shownoflowsupplier = true
  			this.itemselected = true
  			return 
  		}
  		await this.$store.dispatch('evaluation/setMode',"viewing")
  		await this.$store.dispatch('evaluation/setEvaluation',flowsupplierdata.flowsupplier) 
  		await this.$store.dispatch('evaluation/setCustomattributes',flowsupplierdata.customattributes) 
      for(let condition of flowsupplierdata.questionlist_conditions)
      {
        condition.conditions = await JSON.parse(condition.conditions)
        condition.outcome = await JSON.parse(condition.outcome)
      }
      await this.$store.dispatch('evaluation/setQuestionlistConditions',flowsupplierdata.questionlist_conditions) 



  		await this.arrangeAuditInputfields(flowsupplierdata)
  		await console.log(this.$store.state.evaluation)
  		this.selectedsupplier = await data.value
  	},
  	async itemSelected(data)
  	{
  		console.log("itemSelected")  		
  		await this.getFlowsupplierData(data)
  		setTimeout(()=>{
  			this.itemselected = true
  		})
  	},
  	textstart()
  	{
  		this.itemselected = false
  		this.ready_to_upload = false
  		this.shownoflowsupplier = false
  		this.unregistered_smelters = []
  		this.$store.dispatch('evaluation/setEvaluation',null)
  		this.$store.dispatch('evaluation/setSections',null)
	    this.$store.dispatch('evaluation/setInputfields',null)
	    this.$store.dispatch('evaluation/setParentSections',null) 
      this.$store.dispatch('evaluation/setInputfields',null)
      this.$store.dispatch('evaluation/setSections',null)
      this.$store.dispatch('evaluation/setActiveParentSectionId',null) 
  	},
  	onFilesAdded(event)
    {
     setTimeout(()=>{
     	this.handleXml(event.files[0])  
     })         
    },
    getCellValue(column,row)
		{
			let current_cell_address = column+row;				
			let current_cell = this.worksheet[current_cell_address];
			let current_cell_value = (current_cell ? current_cell.v : undefined);
			if(current_cell_value==undefined)
			{
				current_cell_value = ""
			}
			return current_cell_value;

		},
    handleXml(f)
    {    	
    	this.reading_document = true
    	this.ready_to_upload = false
    	let reader = new FileReader()
    	console.log("handleXml");
    	reader.onload = (e)=>{
    		let data = new Uint8Array(e.target.result)
    		this.workbook = XLSX.read(data, {type: 'array'});
    		console.log(this.workbook)
    		//let current_sheet = this.workbook.SheetNames.findIndex(item=>item=="Declaration"); 
    		this.worksheet = this.workbook.Sheets.Declaration; 
    		console.log("worksheet")
    		console.log(this.worksheet)
    		//şirket bilgileri
    		this.submitQuestionData("D",9,1440)	
    		this.submitQuestionData("D",10,1441)	    		
    		this.submitQuestionData("D",12,1442)	    		
    		this.submitQuestionData("D",13,1443)	    		
    		this.submitQuestionData("D",14,1444)	    		
    		this.submitQuestionData("D",15,1445)	    		
    		this.submitQuestionData("D",16,1446)	    		
    		this.submitQuestionData("D",17,1447)	    		
    		this.submitQuestionData("D",18,1448)	    		
    		this.submitQuestionData("D",19,1449)	    		
    		this.submitQuestionData("D",20,1450)	    		
    		this.submitQuestionData("D",21,1451)
    		//şirket bilgileri

    		//select sorular
    		this.submitQuestionData("D",26,1395)
    		this.submitQuestionData("D",27,1396)
    		this.submitQuestionData("D",28,1397)
    		this.submitQuestionData("D",29,1398)

    		this.submitQuestionData("D",32,1399)
    		this.submitQuestionData("D",33,1400)
    		this.submitQuestionData("D",34,1401)
    		this.submitQuestionData("D",35,1402)

    		this.submitQuestionData("D",38,1407)
    		this.submitQuestionData("D",39,1408)
    		this.submitQuestionData("D",40,1409)
    		this.submitQuestionData("D",41,1410)

    		this.submitQuestionData("D",44,1411)
    		this.submitQuestionData("D",45,1412)
    		this.submitQuestionData("D",46,1413)
    		this.submitQuestionData("D",47,1414)

    		this.submitQuestionData("D",50,1415)
    		this.submitQuestionData("D",51,1416)
    		this.submitQuestionData("D",52,1417)
    		this.submitQuestionData("D",53,1418)

    		this.submitQuestionData("D",56,1419)
    		this.submitQuestionData("D",57,1420)
    		this.submitQuestionData("D",58,1421)
    		this.submitQuestionData("D",59,1422)

    		this.submitQuestionData("D",62,1423)
    		this.submitQuestionData("D",63,1424)
    		this.submitQuestionData("D",64,1425)
    		this.submitQuestionData("D",65,1426)

    		this.submitQuestionData("D",68,1427)
    		this.submitQuestionData("D",69,1428)
    		this.submitQuestionData("D",70,1429)
    		this.submitQuestionData("D",71,1430)

    		this.submitQuestionData("D",75,1431)
    		this.submitQuestionData("D",77,1432)
    		this.submitQuestionData("D",79,1433)
    		this.submitQuestionData("D",81,1434)
    		this.submitQuestionData("D",83,1435)
    		this.submitQuestionData("D",85,1436)
    		this.submitQuestionData("D",87,1437)
    		this.submitQuestionData("D",89,1438)
    		//select sorular

    		//smelters
    		this.readSmelters()
    		this.readProducts()
    		//smelters


    		this.reading_document = false
    		this.ready_to_upload = true

			//let current_cell_value =this.getCellValue("D",12)
			//console.log(current_cell_value)
			
    	}
    	reader.readAsArrayBuffer(f);
    },
    async readProducts()
    {
    	this.worksheet = this.workbook.Sheets["Product List"];
    	let lineread = this.readProductsLine(6)
    },
    async readProductsLine(row)
    {
    	let current_cell_value =this.getCellValue("B",row)
    	if(current_cell_value!=="")
    	{
    		this.submitProductLine(row)
    		row++
    		this.readProductsLine(row)    		
    	}
    	else
    	{
    		return "done"
    	}
    },
    submitProductLine(row)
    {
    	let inputfield_id = 1687
    	let inp_ind = this.$store.state.evaluation.inputfields.findIndex(item=>item.id == inputfield_id)

    	if(!this.$store.state.evaluation.inputfields[inp_ind].submissions.length)
    	{
    		this.$store.state.evaluation.inputfields[inp_ind].submissions.push({id:inputfield_id,submission_text:"[]"})
    	}
    	let serial_no = this.getCellValue("B",row)
    	let imalatci = this.getCellValue("C",row)
    	let desc = this.getCellValue("D",row)

    	let sub_obj = {
    		id:this.generateId(),
    		columns:[
    			{id:4506,value:serial_no},
    			{id:4507,value:imalatci},
    			{id:4508,value:desc},
    		]
    	}
    	let submission_text = this.$store.state.evaluation.inputfields[inp_ind].submissions[0].submission_text
    	submission_text = JSON.parse(submission_text)
    	submission_text.push(sub_obj)
    	submission_text = JSON.stringify(submission_text)
    	this.$store.state.evaluation.inputfields[inp_ind].submissions[0].submission_text = submission_text


    },
    async readSmelters()
    {
    	this.worksheet = this.workbook.Sheets["Smelter List"];    	
    	let lineread = this.readSmelterLine(5)
    	console.log("done")


    },
    async readSmelterLine(row)
    {
    	let current_cell_value =this.getCellValue("A",row)
    	if(current_cell_value!=="")
    	{
    		this.submitSmelterLine(row)
    		row++
    		this.readSmelterLine(row)    		
    	}
    	else
    	{
    		return "done"
    	}
    },
    submitSmelterLine(row)
    {
    	let id_cell = this.getCellValue("A",row)
    	let material_cell = this.getCellValue("B",row)
    	let inputfield_id
    	if(material_cell=="Gold")
    	{
    		inputfield_id = 1405
    	}
    	if(material_cell=="Tin")
    	{
    		inputfield_id = 1404
    	}
    	if(material_cell=="Tantalum")
    	{
    		inputfield_id = 1403
    	}
    	if(material_cell=="Tungsten")
    	{
    		inputfield_id = 1406
    	}

    	let inp_ind = this.$store.state.evaluation.inputfields.findIndex(item=>item.id == inputfield_id)

    	if(!this.$store.state.evaluation.inputfields[inp_ind].submissions.length)
    	{
    		this.$store.state.evaluation.inputfields[inp_ind].submissions.push({id:inputfield_id,submission_text:"[]"})
    	}
    	let options = this.$store.state.evaluation.inputfields[inp_ind].options
    	let option  = options.find((item)=>{
    		if(item.name.includes(id_cell))
    		{
    			return item
    		}
    	})
    	if(option)
    	{
    		let submission_text = this.$store.state.evaluation.inputfields[inp_ind].submissions[0].submission_text
    		submission_text = JSON.parse(submission_text)
    		submission_text.push(option.id)
    		submission_text = JSON.stringify(submission_text)
    		this.$store.state.evaluation.inputfields[inp_ind].submissions[0].submission_text = submission_text
    	}
    	else
    	{
    		console.log("option not found")    		
    		this.unregistered_smelters.push(id_cell)
    	}


    	
    },
    async submitQuestionData(column,row,inputfield_id)
    {
    	let current_cell_value =this.getCellValue(column,row)    	
    	let inputfields = this.sanitizeArray(this.$store.state.evaluation.inputfields)
    	let ind = inputfields.findIndex(item=>item.id==inputfield_id)
    	let submission_obj = {
    			id:inputfield_id,
    			evidences:[],
    		}


    	//number
    	if(inputfields[ind].type=="number")
    	{
    		current_cell_value = parseInt(current_cell_value.replaceAll("-",""))
    		submission_obj.submission_numerical = current_cell_value
    	}
    	//number
    	//select
    	if(inputfields[ind].type=="select")
    	{
    		if(current_cell_value=="A. Company")
    		{
    			let option = inputfields[ind].options[0]
    			submission_obj.submission_option = option.id
    		}
    		if(current_cell_value=="B. Product (or List of Products)")
    		{
    			let option = inputfields[ind].options[1]
    			submission_obj.submission_option = option.id
    		}
    		if(current_cell_value=="C. User defined [Specify in 'Description of scope']")
    		{
    			let option = inputfields[ind].options[2]
    			submission_obj.submission_option = option.id
    		}   
    		if(current_cell_value=="Yes")
    		{
    			let option = inputfields[ind].options.find(item=>item.name=="Evet")
    			submission_obj.submission_option = option.id    			
    		} 
    		if(current_cell_value=="No")
    		{
    			let option = inputfields[ind].options.find(item=>item.name=="Hayır")
    			submission_obj.submission_option = option.id
    		} 
    		if(current_cell_value=="Unknown")
    		{
    			let option = inputfields[ind].options.find(item=>item.name=="Hayır")
    			submission_obj.submission_option = option.id
    		} 

    		if(current_cell_value=="100%" || current_cell_value===1)
    		{
    			let option = inputfields[ind].options.find(item=>item.name=="%100")
    			submission_obj.submission_option = option.id
    		} 

    		if(current_cell_value=="Greater than 90%")
    		{
    			let option = inputfields[ind].options.find(item=>item.name=="%90'dan fazla")
    			submission_obj.submission_option = option.id
    		} 

    		if(current_cell_value=="Greater than 75%")
    		{
    			let option = inputfields[ind].options.find(item=>item.name=="%75'den fazla")
    			submission_obj.submission_option = option.id
    		} 

    		if(current_cell_value=="Greater than 50%")
    		{
    			let option = inputfields[ind].options.find(item=>item.name=="%50'den fazla")
    			submission_obj.submission_option = option.id
    		} 

    		if(current_cell_value=="50% or less")
    		{
    			let option = inputfields[ind].options.find(item=>item.name=="%50 veya daha az")
    			submission_obj.submission_option = option.id
    		} 

    		if(current_cell_value=="None")
    		{
    			let option = inputfields[ind].options.find(item=>item.name=="Anket Yapılmadı")
    			submission_obj.submission_option = option.id
    		} 

    		if(current_cell_value=="Yes, in conformance with IPC1755 (e.g., CMRT)")
    		{
    			let option = inputfields[ind].options.find(item=>item.name=="Evet, IPC1755 (ör. CMRT) ile uyumlu")
    			submission_obj.submission_option = option.id
    		} 

    		if(current_cell_value=="Yes, using other format (describe)")
    		{
    			let option = inputfields[ind].options.find(item=>item.name=="Evet, başka bir format kullanarak (açıklayın)")
    			submission_obj.submission_option = option.id
    		} 

    		if(current_cell_value=="Yes, with the SEC")
    		{
    			let option = inputfields[ind].options.find(item=>item.name=="Evet, SEC ile")
    			submission_obj.submission_option = option.id
    		} 

    		if(current_cell_value=="Yes, with the EU")
    		{
    			let option = inputfields[ind].options.find(item=>item.name=="Evet, AB ile")
    			submission_obj.submission_option = option.id
    		} 

    		if(current_cell_value=="Yes, with the SEC and the EU")
    		{
    			let option = inputfields[ind].options.find(item=>item.name=="Evet, SEC ve AB ile")
    			submission_obj.submission_option = option.id
    		} 


    		let sub_note_cell = this.getCellValue("G",row)
    		if(sub_note_cell=="")
    		{
    			submission_obj.submission_note = "Not available"
    		}
    		else
    		{
    			submission_obj.submission_note = sub_note_cell
    		}
    			
    	}
    	//select
    	//text
    	if(inputfields[ind].type=="text" || inputfields[ind].type=="longtext")
    	{
    		submission_obj.submission_text = current_cell_value
    	}
    	//text


    	

    	this.$store.state.evaluation.inputfields[ind].submissions.push(submission_obj)
    	this.$store.state.evaluation.inputfields[ind].completion = true
    	this.$store.state.evaluation.inputfields[ind].show_info_textarea = true

    	
    	this.checkQueslionlistConditions()
    	
    },
  }
}
</script>

<style lang="css" >
	.p-autocomplete-input{
		width: 100%;
	}
</style>